import { Link } from 'react-router';

export function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-hairline bg-surface">
      <div className="mx-auto grid max-w-[var(--container-app)] grid-cols-[minmax(0,1fr)] gap-10 px-5 py-12 md:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1fr)]">
        <div>
          <img src="/leza-logo.png" alt="LEZA Kennisbank" className="h-10 w-auto" />
          <p className="mt-3 max-w-xs text-base text-ink-3">
            Handleidingen, koppelingen en video&apos;s voor al je vragen.
          </p>
        </div>
        <nav aria-label="Snel naar">
          <h2 className="text-2xs font-semibold tracking-wider text-ink-3 uppercase">Snel naar</h2>
          <ul className="mt-3 space-y-2 text-base">
            <li><Link viewTransition className="text-ink-2 transition hover:text-ink" to="/search?sort=newest">Nieuwste artikelen</Link></li>
            <li><Link viewTransition className="text-ink-2 transition hover:text-ink" to="/search?sort=popular">Meest bekeken</Link></li>
            <li><Link viewTransition className="text-ink-2 transition hover:text-ink" to="/search">Alle artikelen</Link></li>
          </ul>
        </nav>
        <div>
          <h2 className="text-2xs font-semibold tracking-wider text-ink-3 uppercase">Contact</h2>
          <p className="mt-3 text-base text-ink-3">Vraag niet gevonden? We helpen je graag verder.</p>
          <a
            href="mailto:info@leza.nl"
            className="mt-3 inline-block rounded-md border border-hairline-strong px-4 py-2 text-base font-medium text-ink-2 transition hover:border-accent hover:text-ink"
          >
            Mail ons
          </a>
        </div>
      </div>
      <div className="border-t border-hairline">
        <div className="mx-auto max-w-[var(--container-app)] px-5 py-4 text-sm text-ink-3">
          <span>© {new Date().getFullYear()} LEZA Kennisbank</span>
        </div>
      </div>
    </footer>
  );
}
